import styled from "styled-components"

import { Button, spacing, Text } from "@minuthq/meatball-ui-react"

import { detailsBreakpoint } from "src/components/GuestInbox/GuestConversations/guestConversationStyles"
import { TGuest } from "src/data/guests/types/guestTypes"
import { useTranslate } from "src/i18n/useTranslate"

export function GuestConversationHeader({
  guest,
  onResolve,
  onDetailsClick,
}: {
  guest: TGuest
  onResolve: () => void
  onDetailsClick: () => void
}) {
  const { tPlaceholder } = useTranslate()

  return (
    <Wrapper>
      <Text variant="heading3">{guest.name}</Text>
      <ButtonsWrapper>
        <DetailsButton
          variant="minimal"
          color="neutral"
          onClick={onDetailsClick}
        >
          {tPlaceholder("Details")}
        </DetailsButton>

        <Button color="neutral" size="small" onClick={onResolve}>
          {tPlaceholder("Resolve")}
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ButtonsWrapper = styled.div`
  display: flex;
  gap: ${spacing.S};
`

const DetailsButton = styled(Button)`
  @container (${detailsBreakpoint}) {
    display: none;
  }
`
